module.exports = __webpack_public_path__ + "img/feature_buy_zh.a9d00477.png";